import styled, { css } from "styled-components";

export const AccordionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AccordionItem = styled.div``;

export const AccordionTitle = styled.h3<{
  $activeColor: "primary" | "secondary" | "default";
  $whiteBackground: boolean;
  $active: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 12px;
  border-radius: 12px;
  font-weight: 600;
  background: ${(props) =>
    props.$whiteBackground
      ? props.theme.colors.base
      : props.theme.colors.default[50]};
  color: ${({ theme, $active, $activeColor }) =>
    $active
      ? theme.colors[$activeColor].default
      : theme.colors.default.default};
`;

export const AccordionContent = styled.div`
  padding: 12px 12px 0 12px;
  height: 100%;
  width: 100%;
`;

export const AccordionContentWrapper = styled.div`
  overflow: clip;
`;

export const ArrowContainer = styled.span<{ $expanded: boolean }>`
  transition: 0.2s;

  span {
    svg {
      width: 14px;
    }
  }

  ${(props) =>
    props.$expanded &&
    css`
      transform: rotate(180deg);

      span svg path {
        stroke: ${(props) => props.theme.colors.base};
      }
    `}
`;
